import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import { useMutes } from "../../context/Mutes/MutesContext";

const MuteDialog = ({ open, contactId, isGroup, onClose }) => {
  const { mute } = useMutes();
  const [duration, setDuration] = useState("8h");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setDuration("8h");
  }, [open]);

  const handleConfirm = async () => {
    setSaving(true);
    try {
      await mute(contactId, duration);
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{i18n.t("mutes.title")}</DialogTitle>
      <DialogContent>
        <RadioGroup value={duration} onChange={(e) => setDuration(e.target.value)}>
          <FormControlLabel value="8h" control={<Radio color="primary" />} label={i18n.t("mutes.d8h")} />
          <FormControlLabel value="1w" control={<Radio color="primary" />} label={i18n.t("mutes.d1w")} />
          <FormControlLabel value="always" control={<Radio color="primary" />} label={i18n.t("mutes.always")} />
        </RadioGroup>
        <Typography variant="body2" color="textSecondary" style={{ marginTop: 12 }}>
          {i18n.t("mutes.hint")}
          {isGroup ? ` ${i18n.t("mutes.groupHint")}` : ""}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          {i18n.t("mutes.cancel")}
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained" disabled={saving}>
          {i18n.t("mutes.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MuteDialog;
